import React from 'react'

import Base from '../_Base'

const AuPg = (props) => (
  <Base width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
    <path
      d="M24.0249 21.9975C24.0249 23.0983 23.123 24 22.0263 24H2.02349C0.922574 24 0.0249023 23.0983 0.0249023 21.9975V1.99824C0.0249023 0.897513 0.922574 0 2.02349 0H22.0263C23.1272 0 24.0249 0.897513 24.0249 1.99824V21.9975Z"
      fill="white"
    />
    <path
      d="M22.9319 21.0902C22.9319 22.0908 22.1121 22.9106 21.1154 22.9106H2.93447C1.93383 22.9106 1.11792 22.0908 1.11792 21.0902V2.90932C1.11792 1.90868 1.93383 1.09277 2.93447 1.09277H21.1154C22.116 1.09277 22.9319 1.90868 22.9319 2.90932V21.0902Z"
      fill="#FFF200"
    />
    <path
      d="M8.94582 13.0579H7.39483V16.0945H5.81689V8.02393H8.94582C10.6123 8.02393 11.6091 9.17081 11.6091 10.5409C11.6091 11.911 10.6123 13.0579 8.94582 13.0579ZM8.86885 9.42867H7.39483V11.6416H8.86885C9.58469 11.6416 10.0388 11.199 10.0388 10.5409C10.0388 9.88281 9.58469 9.42867 8.86885 9.42867Z"
      fill="#231F20"
    />
    <path
      d="M17.4591 15.2478C16.8125 15.9174 16.0428 16.1638 15.1807 16.1638C14.3186 16.1638 13.572 15.8482 13.0024 15.2786C12.1864 14.4627 12.2095 13.4543 12.2095 12.0611C12.2095 10.6679 12.1864 9.65959 13.0024 8.84368C13.5681 8.27793 14.2724 7.9585 15.1807 7.9585C17.0511 7.9585 18.0017 9.18236 18.2172 10.5448H16.6316C16.4507 9.78659 15.985 9.36709 15.1807 9.36709C14.7496 9.36709 14.3956 9.53643 14.1723 9.79814C13.8644 10.1368 13.7836 10.514 13.7836 12.065C13.7836 13.616 13.8644 14.0047 14.1723 14.3434C14.3956 14.6051 14.7496 14.7629 15.1807 14.7629C15.6579 14.7629 16.0389 14.5935 16.3045 14.3087C16.5623 14.0162 16.6662 13.6506 16.6662 13.235V12.9309H15.1807V11.6147H18.2288V12.7924C18.2288 13.9623 18.0248 14.6628 17.4591 15.2555V15.2478Z"
      fill="#231F20"
    />
    <path
      d="M20.0608 5.89941H3.72729V18.088H20.3187V5.89941H20.057H20.0608ZM19.7953 6.42283V17.5646H4.25456C4.25456 17.0758 4.25456 6.9116 4.25456 6.42283H19.7991H19.7953Z"
      fill="#231F20"
    />
  </Base>
)

export default AuPg
